<template>
  <div id="saved_graph">
    <div class="d-flex justify-content-between">
      <!-- show graph data userwise -->
      <div class="mb-1">
        <i
          class="box-icon box-icon--effect bx bx-user-circle"
          :class="{ 'box-icon--active': showMyGraphs }"
          :title="showMyGraphs ? 'Show All Graphs' : 'Show My Graphs'"
          @click="toggleShowGraphs"
        ></i>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center" v-if="isFiltered">
      <a class="d-flex box-icon" @click="goBack()">
        <box-icon name="chevron-left"></box-icon>
        <div>Back</div>
      </a>
    </div>
    <ul class="list-group">
      <li
        class="save_graph_li"
        v-for="graph of allGraph"
        :key="graph._id"
        :class="{
          'list-group-item': true,
          graph__activate: isActive(graph._id) && !isUpdate,
          'list-group-item-warning': isActive(graph._id) && isUpdate,
        }"
      >
        <!-- <span>-- {{graph}} <br></span> -->
        <div class="d-flex">
          <div>
            <span
              v-if="!isFormActive(graph._id)"
              class="saved_label"
              @click="getGraph(graph)"
            >
              <strong>{{ graph.g6_data.graph_name }}</strong>
            </span>
            <!-- <span v-if="isFormActive(graph._id)">
              <input type="text" v-model="graph_detail.graph_name" />
            </span> -->
            <span v-if="!isFormActive(graph._id)" class="graph__category">
              {{ graph.g6_data.graph_type[0] }}
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div>
            <!-- <span v-if="isFormActive(graph._id)"> -->
            <!-- <select
                class="form-select form-select-sm select-cat"
                aria-label="Select Categories"
                v-model="graph_detail.graph_type"
                title="Select Category"
              >
                <option
                  class="select-cat__option"
                  v-for="category in categories"
                  :value="category"
                  :key="category"
                >
                  {{ category }}
                </option>
              </select>
            </span> -->
          </div>
          <div v-if="isFormActive(graph._id)" class="graph-lib__edit-form">
            <div class="graph-lib__input-form">
              <label class="ed-label">Graph Name</label>
              <ed-input
                :onChange="setGraphName"
                :value="graph_detail.graph_name"
                placeholder="Enter the Graph Name"
              />
            </div>
            <div class="graph-lib__input-form">
              <label class="ed-label">Select Category</label>
              <!-- <select
                class="form-select form-select-sm select-cat graph-lib__edit-form__dropdown"
                aria-label="Select Categories"
                v-model="graph_detail.graph_type"
                title="Select Category"
              >
                <option
                  class="select-cat__option"
                  v-for="category in categories"
                  :value="category"
                  :key="category"
                >
                  {{ category }}
                </option>
              </select> -->
              <ed-dropdown
                :listItems="categories"
                :selected="graph_detail.graph_type"
                :isSelected="setGraphType"
              />
            </div>
            <div class="graph-lib__input-form">
              <label class="ed-label">Tags</label>
              <ed-input
                :onChange="setGraphTags"
                placeholder="eg: animal, tech, naruto"
                :value="graph_detail.graph_tags"
              />
            </div>
          </div>
        </div>
        <span v-if="graph.tags.length > 0 && !isFormActive(graph._id)">
          <span
            class="graph_tags px-1"
            :style="{ color: getRandomColor() }"
            @click="fetchByTag(tag)"
            v-for="tag in graph.tags"
            :key="tag.id"
            >#{{ tag.name }}</span
          >
        </span>
        <div class="saved_graph_box">
          <!-- <span v-if="isFormActive(graph._id)">
            <input type="text" v-model="graph_detail.graph_tags" />
          </span> -->
          <i
            v-if="
              isAccess(graph.actor === null ? 'someone' : graph.actor.username)
            "
            title="Delete graph"
            class="saved_graph_box__icon box-icon bx bx-trash"
            @click="deleteGraph(graph._id)"
          ></i>
          <i
            title="Edit Graph"
            v-if="
              isActive(graph.id) &&
              isAccess(graph.actor === null ? 'someone' : graph.actor.username)
            "
            @click="toggleForm(graph.id)"
            class="saved_graph_box__icon saved_graph_box__icon--highlight bx bx-edit-alt"
          ></i>
          <i
            title="Update graph"
            v-if="
              isActive(graph.id) &&
              isAccess(graph.actor === null ? 'someone' : graph.actor.username)
            "
            @click="saveForm(graph.id)"
            class="saved_graph_box__icon box-icon bx bx-save"
          ></i>
          <i
            title="Share graph"
            class="saved_graph_box__icon box-icon bx bx-share"
            @click="shareUrl(graph._id, $event)"
            @mouseout="tooltipOut"
          >
          </i>
          <i
            title="Preview"
            class="saved_graph_box__icon box-icon bx bx-expand-alt"
            @click="previewGraph(graph._id)"
          ></i>
          <i
            title="Add to Graph"
            class="saved_graph_box__icon box-icon bx bx-cloud-snow"
            @click="addToThoughtMap(graph)"
          ></i>
        </div>
        <div class="author-container">
          <span class="author-name" v-if="!isFormActive(graph._id)">
            @{{ graph.actor === null ? "someone" : graph.actor.username }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import swal from 'sweetalert';
import chroma from 'chroma-js';
import graphReactor from '@/graphReactor';
import edInput from './ed-forms/ed-input.vue';
import edDropdown from './ed-forms/ed-dropdown.vue';
/* eslint-disable no-underscore-dangle */

export default {
  async mounted() {
    await this.fetchAllGraph();
  },
  components: {
    edInput,
    edDropdown,
  },

  data() {
    return {
      graphData: [],
      showMyGraphs: false,
      categories: [
        'Science',
        'Technology & Gadgets',
        'Entertainment & Media',
        'Business',
        'Games & Sports',
        'Art & Culture',
        'Educational',
        'Travel - Holidays, Places',
        'Food & Drinks',
        'History & Events',
        'Finances',
        'Health & Wellbeing',
        'Uncategorized',
      ],
      listToggle: {
        id: null,
        show: false,
      },
      graph_detail: {
        graph_name: '',
        graph_type: '',
        graph_tags: '',
      },
      isUpdate: false,
      isFiltered: false,
    };
  },

  computed: {
    userNameState() {
      return this.$store.state.auth.user.username;
    },
    allGraph() {
      // eslint-disable-next-line
      return this.$store.state.saved_graph_list;
    },
    // getRandomColor() {
    //   return chroma.random().darken().hex();
    // },
  },

  created() {
    // this.unsubscribe = this.$store.subscribe((mutation) => {
    //   if (mutation.type === 'SET_SAVED_GRAPH') {
    //     this.fetchAllGraph();
    //   }
    // });
  },
  sockets: {
    newNotification(message) {
      const msg = JSON.parse(message);
      if (msg.verb.display.en === 'GRAPHED') {
        this.fetchAllGraph();
      }

      if (msg.verb.display.en === 'DELETED_GRAPH') {
        this.fetchAllGraph();
      }

      if (msg.verb.display.en === 'UPDATED_GRAPH') {
        if (this.$store.state.auth.user.username === msg.actor.username) {
          this.isUpdate = false;
          this.fetchAllGraph();
        }
      }
    },
  },

  watch: {
    showMyGraphs(flag) {
      if (flag) {
        this.fetchGraphData({ user: '@me' });
      } else {
        this.fetchGraphData({ user: '@all' });
      }
    },
  },

  methods: {
    async fetchGraphData(payload) {
      const res = await this.$store.dispatch('fetchAllGraph', payload);
      this.graphData = res;
    },

    tooltipOut(elem) {
      // eslint-disable-next-line
      elem.target.setAttribute('title', 'Copy embed code');
    },

    selectCategory(tab) {
      this.selectedCategories = tab;
    },

    goBack() {
      this.fetchAllGraph();
    },

    isAccess(username) {
      return (
        this.userNameState === username
        || this.$store.state.admin.includes(this.userNameState)
      );
    },

    isFormActive(id) {
      return this.listToggle.id === id && this.listToggle.show;
    },

    toggleForm(id) {
      const val = this.listToggle;
      this.listToggle = {
        id,
        show: !val.show,
      };
      console.log(this.listToggle.show, 'GAME');
      if (this.listToggle.show === false) {
        const payload = {
          id,
          gdata: graphReactor.exploreInstance.save(),
          graph_name: this.graph_detail.graph_name,
          graph_type: [this.graph_detail.graph_type],
          graph_tags: this.graph_detail.graph_tags,
        };
        this.isUpdate = true;
        this.$store.dispatch('gmodule/updateGraph', payload).then(() => {
          this.isUpdate = false;
        });
      }
    },

    saveForm(id) {
      const payload = {
        id,
        gdata: graphReactor.exploreInstance.save(),
        graph_name: this.graph_detail.graph_name,
        graph_type: [this.graph_detail.graph_type],
        graph_tags: this.graph_detail.graph_tags,
      };
      this.isUpdate = true;
      this.$store.dispatch('gmodule/updateGraph', payload).then(() => {
        this.isUpdate = false;
      });
    },

    getRandomColor() {
      return chroma.random().darken().hex();
    },
    previewGraph(id) {
      const pLink = document.createElement('a');
      pLink.setAttribute('href', `/embed/GraphFrame/${id}`);
      pLink.setAttribute('target', '_blank');
      pLink.click();
      pLink.remove();
      this.$store.commit('SET_ACTIVE_GRAPH_ID', id);
    },
    shareUrl(id, $event) {
      const codePaste = `
      <iframe width="100%" height="840" src="${window.location.origin}/embed/GraphFrame/${id}"></iframe>
      `;
      navigator.clipboard.writeText(codePaste);
      // eslint-disable-next-line
      $event.target.setAttribute('title', 'Copied');
    },
    isActive(id) {
      return this.$store.state.active_graph_id === id;
    },
    async fetchAllGraph() {
      await this.$store.dispatch('fetchAllGraph', {
        user: this.selectedCategories,
      });
      this.isFiltered = false;
    },
    async fetchByTag(val) {
      const { _id, name } = val;
      console.log(_id, name);
      // eslint-disable-next-line
      await this.$store.dispatch("fetchGraphByTag", name);
      this.isFiltered = true;
    },
    deleteGraph(id) {
      this.$store.dispatch('gmodule/deleteGraph', id);
    },
    updateGraph(id) {
      this.$store.dispatch('gmodule/updateGraph', {
        id,
        gdata: graphReactor.exploreInstance.save(),
      });
      this.isUpdate = true;
    },
    getGraph(graph) {
      this.listToggle = {
        id: null,
        show: false,
      };
      console.log(graph._id);
      this.$store.dispatch('gmodule/getGraph', graph._id).then(() => {
        this.$store.commit('SET_ACTIVE_GRAPH_ID', graph._id);
      });
      this.graph_detail = {
        graph_name: graph.g6_data.graph_name,
        graph_type: graph.g6_data.graph_type[0],
        graph_tags: graph.tags.map((tag) => tag?.name).join(', '),
      };
    },

    // AddToThoughMat
    addToThoughtMap(graph) {
      const payload = {
        graphId: graph._id,
        graphName: graph.g6_data.graph_name,
      };
      console.log('Add To ThoughtMap', payload);
      this.$store.dispatch('gmodule/addToThoughtMap', payload);
    },

    setGraphName(val) {
      this.graph_detail.graph_name = val;
    },
    setGraphTags(val) {
      this.graph_detail.graph_tags = val;
    },
    setGraphType(val) {
      this.graph_detail.graph_type = val;
    },
    toggleShowGraphs() {
      this.showMyGraphs = !this.showMyGraphs;
    },
  },
  beforeDestroy() {
    // this.unsubscribe();
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/abstracts/variables";
.saved_label {
  cursor: pointer;
  // text-decoration: underline;
  color: $edvantaBlue;
  text-transform: capitalize;
}

.tooltiptext {
  visibility: hidden;
  width: 140px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -75px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltiptext {
  visibility: visible;
  opacity: 1;
}

.graph {
  &__activate {
    background: rgba($secondaryBlue, 0.1) !important;
  }
  &__category {
    display: block;
    // white-space: nowrap;
    color: $gray;
    font-size: 0.9rem;
  }
}

.graph-lib {
  &__edit-form {
    margin-bottom: 1.3rem;
    &__text {
      width: 100%;
      font-family: inherit;
      margin-bottom: 0.5rem;
      padding: 0.1rem;
      padding-left: 0.4rem;
      border-radius: 0.3rem;
    }
    &__dropdown {
      width: 100%;
      font-family: inherit;
      margin-bottom: 0.5rem;
    }
  }
  &__input-form {
    margin-bottom: 0.5rem;
  }
}

.select-cat {
  width: auto;
  text-transform: uppercase;
  font-weight: bold;
  border: none;
  padding: 0.5em;
  border-radius: 5px;
  transition: all ease-in-out 200ms;

  &:hover {
    background-color: $edvantaButtonColor;
    cursor: pointer;
  }

  &:focus,
  &:active {
    outline: none;
    border: none;
    box-shadow: none;
  }
}

.graph_tags {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  &__container {
    transition: all 0.3s ease-in-out;
    // color: $color-grey-1;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

.author-name {
  font-size: 0.85rem;
  font-style: italic;
}

#saved_graph {
  .save_graph_li {
    min-height: 200px;
    padding: 10px;
    position: relative;

    &:hover > .saved_graph_box,
    &:hover > .tag-container {
      display: flex;
    }
  }
  .categories {
    position: absolute;
    bottom: 0;
    left: 5px;
    padding-top: 15px;
    padding-right: 5px;
  }
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    padding: 0.8rem 0;
  }
  .author-container {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0.8rem;
    bottom: 0.5rem;
  }
  .saved_graph_box {
    // width: 70px;
    // height: 100%;
    display: none;
    position: absolute;
    padding-top: 1rem;
    padding-left: 0.8rem;
    right: 0.5rem;
    bottom: 2rem;
    justify-content: center;
    align-items: center;

    &__icon {
      transition: all 0.3s ease-in-out;
      fill: $color-grey-1;
      margin-left: 0.3rem;
      &:hover {
        // padding: 5px;
        transform: translateY(-3px);
        background-color: rgba(243, 243, 243, 0.664);
        fill: $gray;
        border-radius: 50%;
        cursor: pointer;
      }
      &--highlight {
        fill: $edvantaBlue;

        &:hover {
          fill: $edvantaBlue;
        }
      }
    }
  }
}
</style>
